/**
 * Service worker registration.
 *
 * Registered only in a production build. In development CRA serves an
 * unhashed bundle from memory and rebuilds constantly, so a worker there
 * mostly succeeds at serving yesterday's code — the classic "why is my change
 * not showing" afternoon.
 *
 * Registration is also skipped unless the page is in a secure context, because
 * a worker is simply not available on plain http from another machine, and a
 * rejected promise in the console reads like a bug rather than a fact of life.
 */

const isLocalhost = () =>
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1", "[::1]"].includes(window.location.hostname);

export function register(onUpdateAvailable) {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  if (process.env.NODE_ENV !== "production") return;
  if (!window.isSecureContext && !isLocalhost()) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        reg.addEventListener("updatefound", () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener("statechange", () => {
            // "installed" with an existing controller means a new build is
            // waiting. It is not applied until the page asks — see sw.js
            // rule 4 for why nothing swaps mid-audit.
            if (installing.state === "installed" && navigator.serviceWorker.controller) {
              if (onUpdateAvailable) onUpdateAvailable(reg);
            }
          });
        });
      })
      .catch(() => {
        // A failed registration costs the offline shell, not the app. The
        // audit itself is in IndexedDB either way.
      });
  });
}

/** Apply a waiting update. The caller reloads once the new worker is active. */
export function applyUpdate(registration) {
  if (!registration || !registration.waiting) return;
  registration.waiting.postMessage({ type: "SKIP_WAITING" });
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    window.location.reload();
  });
}

export function unregister() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  navigator.serviceWorker.ready
    .then((reg) => reg.unregister())
    .catch(() => {});
}
